import { EMRDatabase } from '../index';

export class MainThreadDB extends EMRDatabase {}
export const mainDB = new MainThreadDB();
